import polyglotI18nProvider from "ra-i18n-polyglot";
import themeConfig from "../config";

const englishMessages = {
  ra: {
    no_records: "No records",
    weekDays: {
      sunday: "Sunday",
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      day: "Day"
    },
    errorChangePassword: {
      minimum_characters:"The minimum password length is 8 characters",
      containts_name_institution: "Password cannot contain institution name",
      containts_three_consecutive: "The password cannot contain three consecutive identical characters",
      have_one_letters: "Password must have at least one letter",
      have_one_number: "Password must have at least one number",
      have_special_character: "Password must have at least one special character",
      have_blank_spave: "The password cannot contain blank spaces",
      repeat_password: "La contraseña no debe ser la misma que las 5 últimas utilizadas"
    },
    auth: {
      auth_check_error: "Please login to continue",
      usernameField: "Username",
      passwordField: "Password",
      emailField: "Enter your email",
      verificationCodeField: "Verification code",
      newPasswordField: "New password",
      newPasswordConfirmField: "New password confirmation",
      otpField: "Enter Otp",
      forgotPassword: "Forgot you password?",
      resendVerificationEmail: "User vefication",
      title: "Password Reset",
      title_otp: "Otp Verify",
      description:
        "We have sent a verification code to your email, please enter it in the verification field.",
      invalid_password: "Invalid password",
      verification_failed:"Verification failed, please enter your email in user verification",
      user_confirmed: "User confirmed successfully",
      user_change_confirmed: "User confirmed successfully, changes will be reflected in the next login",
      user_not_cofigure: "The user cannot be edited at this time",
      verifyingAccount: "Verifying account...",
      limitPassword: "Your password expires in:",
      change_password: "It is necessary to change the user's password.",
      success_change_password: "Success change password.",
      success_resend_otp: "OTP security code forwarded to your email",
      error_resend_otp: "There is an error resending the OTP security code",
      pin_bancaribe: "Enter PIN",
      error_pin: "The PIN must be 4 digits"
    },
    notification: {
      http_error: "Network error. Please retry",
      terminal_not_found_error: "The terminal does not exist",
      server_error: "Internal server error",
      updated_success: "Resource updated successfully",
      created_success: "Resource created successfully",
      deleted_success: "Resource deleted successfully",
      not_found: "Resource not found",
      unexpected_error: "Ooops, an error occurred, try again",
      password_changed_success: "Password changed successfully",
      invalid_code_error: "Invalid verification code",
      password_not_same_error: "Passwords are not the same",
      invalid_email_error: "Invalid email",
      check_email_success: "Check your email",
      cannot_delete_resource:
        "The resource cannot be deleted, because it is parent of other data.",
      cannot_delete_resource_banks:"Cannot delete because resources (%{banks}) is related to a business.",
      fields_required: "Some fields are empty",
      extension_not_allowed: "Extension not allowed",
      time_session: "Session time expired",
      already_exist_resource: "Resource already exist",
      not_existence:"The product is out of stock",
      already_exist_rif: "The Merchant ID already exist",
      required_rif:"Merchant identification is required",
      required_sec_currency: "Secudary currency is required",
      required_currency_rate: "Rate change is required",
      min_value_surcharge_cashdiscount:
        "Cash discount or surcharge cannot be lees than 1,00",
      max_value_surcharge_cashdiscount:
        "Cash discount or surcharge cannot be greater than 4,00",
      max_value_taxes: "General tax or state tax cannot be greater than 100,00",
      min_value_taxes: "General tax or state tax cannot be lees than 1,00",
      account_already_confirmed: "This account is already confirmed.",
      user_not_exist: "This user not exist.",
      exceeded_limit:
        "You have exceeded the number of attempts, please try again later.",
      max_price: "Max Amount is 9.999.999,99$",
      min_price: "Min Amount is 0,01$",
      min_phone_number: "The phone number must have at least 10 characters",
      deleted_error: "You cannot delete the user who is in session",
      password_temporal_not_found: "You cannot change password without an associated user",
      otp_not_found: "You cannot add password without an associated user",
      otp_not_equeals: "the otp is not correct",
      otp_expired: "Invalid session for the user, please resend otp",
      enter_otp: 'Please enter the security code we sent to your email',
      resend_otp: 'Resend security code',
      resend_otp_in: 'Your code expires in ',
      seconds: "seconds.",
      password_temporal_not_process: "Unable to process password change at this time",
      pin_not_process: "Unable to process PIN change at this time",
      pin_changed_success: "PIN changed successfully",
      columns_not_found:"Columns not found check our template, the columns not found are: %{columns}",
      product_load:"You must first load the products in order to move forward",
      created_success_stock:"Products successfully updated, out of %{total} products %{products} were updated, the updated products were: %{products_names}",
      created_success_product:"Products (%{total}) created successfully",
      created_success_images:"Images (%{total}) successfully saved",
      error_product_quantity : "Product quantity with negative values is not allowed. %{products} product(s) with negative values were found.",
      error_special_characters : "Special characters are not allowed in the price and quantity columns.",
      error_id: "The following product IDs do not exist: %{ids}",
      error_product_price : "Product price with negative values is not allowed. %{products} product(s) with negative values were found.",
      error_special_characters_quantity : "Special characters are not allowed in the quantity column.",
      quantity_error:"You must add an quantity",
      catalogOrKeyboardAmount: "You must select at least one option between Catalog and Keyboard Amount",
      acceptTerms:"You must accept the terms and conditions",
      min_price_change: "Minimum amount for change is $0.01",
      invalid_business_name: "The business name cannot contain special characters",
      invalid_branch_name: "The branch name cannot contain special characters",
      invalid_branch_merchant_id_min :"The business Rif must be at least 7 characters long.",
      invalid_branch_merchant_id_max :"The business Rif cannot be longer than 10 characters.",
      invalid_branch_account_number :"The account number must be exactly 20 characters long."
    },
    action: {
      create: "Create",
      save: "Save",
      edit: "Edit",
      editImage: "Edit image",
      cancel: "Candel",
      delete: "Delete",
      addFilter: "Add filter",
      export: "Export",
      logout: "Log out",
      goBack: "Go Back",
      update: "Update",
      quickFilter: "Quick filter",
      select: "Select",
      search: "Search",
      login: "Sign in",
      resetPassword: "Reset password",
      resentPassword: "Resent password",
      newPassword: "Set new password",
      continue:"Continue",
      extend: "Extend",
      close: "Close",
      retry: "Retry",
      load: "Load",
      submit: "Submit",
      changePassword: "Change password",
      firstPage: "First page",
      lastPage: "Last page",
      from: "From",
      to: "To",
      dateRange: "Date Range",
      userSettings: "Custom view",
      userProfile: "User Settings",
      clear: "Clear",
      discharge: "Discharge",
      zoom: "Zoom",
      changePin: "Change PIN",
      newPin: "Set new pin",
      batch:"Load products in batches",
      next:"Next",
      back:"Back",
      finish:"Finish",
      stock:"Load stock in batches",
      remove:"Remove",
      add:"Add"
    },
    page: {
      not_found: "Page not found",
      page: "Page",
      of: "of",
    },
    message: {
      not_found: "Resource not found.",
      time_logout: "Less than 30 seconds left to log out.",
      error_get_data:
        "Unexpected error while receiving data, please try again.",
      confirm: "Confirm",
      cancel: "Cancel",
      stock:"To load the stock by lot you must upload an Excel file with the id, name and quantity, here you can download the Excel file with the existing products, just change the quantity positive if you are going to add (20) and negative if you are going to subtract (-20)",
      productBatch:"For the massive upload of products you must upload an Excel file with the name, description, price (USD) and quantity, in the button 'DOWNLOAD TEMPLATE' you can download an example.",
      imageZip:"For the bulk upload of images you must upload a zip file containing the images of the products, each image must have the same name as the product previously added otherwise they will not be saved."
    },
    views: {
      dashboard: {
        title: "Dashboard",
        dailySales: "Daily Sales",
        weeklySales: "Weekly Sales",
        monthlySales: "Monthly Sales",
        dailyC: "Daily comparison",
        weeklyC: "Weekly comparison",
        monthlyC: "Monthly comparison",
        current: "Current",
        previous: "Previous",
        yesterday: "Yesterday",
        salesAmount: "Operations graph",
        today: "Today",
        week: "Week",
        monthByWeek: "Month by week",
        monthByDay: "Month by day",
      },
      settings: {
        title: "Settings",
        titleAdjustmentBusinesses: "Adjustment to Businesses",
        titleUsers: "Users",
        titleBranches: "Branches",
        titleTerminals:"Terminals",
        titleProducts: "Products",
        converter: "Currency converter",
        language: "Language",
        businessRegister: "Merchant ID",
        businessName: "Business name",
      },
      products: {
        title: "Products",
        create: "Create Product",
        edit: "Edit Product",
        detail: "Detail Product",
        delete: "Are you sure to remove this product",
        delete_several: "¿Está seguro de eliminar",
        loadFile: "Load images file to zip",
        loadFileImages: "Load images file",
        loadFileStock: "Load stock file",
        onlyFormat:"Only .zip file",
      },
      categories: {
        title: "Categories",
        create: "Create Category",
        edit: "Edit Category",
        delete: "Are you sure to remove this Category?",
        delete_several: "Are you sure to delete the selected resources?",
      },
      terms:{
        title: "TERMS AND CONDITIONS BANCARIBE DIGITAL CASH OFFICE",
        Content:"What is Lorem Ipsum? Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
      },
      users: {
        title: "Users",
        create: "Create User",
        edit: "Edit User",
        detail: "Detail User",
        delete: "Are you sure to remove this user",
        delete_several: "Are you sure to delete the selected resources?",
        cancel: "Cancel",
        save: "Save",
      },
      business: {
        title: "Business",
        create: "Create Business",
        edit: "Edit Business",
        detail: "Detail Business",
        delete: "Are you sure to remove this business",
        delete_several: "Are you sure to delete the selected resources?",
        loadFile: "Load products file",
      },
      branches: {
        title: "Branches",
        create: "Create Branch",
        edit: "Edit Branch",
        detail: "Detail Branch",
        delete: "Are you sure to remove this branch",
        delete_several: "Are you sure to delete the selected resources?",
      },
      terminals: {
        title: "Terminals",
        create: "Create Terminal",
        edit: "Edit Terminal",
        detail: "Detail Terminal",
        dropFile: "Drop an file here!!",
        orClickFile: "Or click here to upload file",
        onlyFormat: "Only excel or csv files",
        loadFile: "Select File",
        downloadTemplate: "Download template",
        delete: "Are you sure to remove this terminal",
        delete_several: "Are you sure to delete the selected resources?",
        bulkLoad: "bulk terminal upload",
        textUpload:"Drop a file here or click to upload. Only excel or csv files",
        textUploadTxt:"Drop a file here or click to upload. Only .txt file",
        textUploadZip:"Drop a file here or click to upload. Only .zip file",
      },
      orders: {
        title: "Sales",
        ordersTotal: "Sales: ",
        ordersSales: "Amount: ",
        orderDetail: "Sales Details: ",
        transactionDetail: "Transaction Details: ",
      },
      transactions: {
        title: "Transactions",
        create: "Create Transaction",
        edit: "Edit Transaction",
        detail: "Detail Transaction",
        delete: "Are you sure you want to delete this transaction?",
        delete_several: "Are you sure you want to delete the selected resources?",
        transactionTotal: "Transactions: ",
        transactionSales: "Sales: ",
      },
      reports: {
        title: "Reports",
        titleCustomR: "Custom Report",
        titleSoldP: "Sold Products",
        titleCloseR:"Closing Report",
      },
      networkSettings: {
        title: "Network Settings",
        features: {
          title: "Features",
          create: "Create Feature",
          edit: "Edit Feature",
          delete: "Are you sure to remove this feature",
          delete_several: "¿Está seguro de eliminar",
        },
        payment_methods: {
          title: "Payment Methods",
          create: "Create Payment Method",
          edit: "Edit Payment Method",
          delete: "Are you sure you want to delete this payment method?",
          delete_several: "Are you sure you want to delete the selected resources?",
        },
        processors: {
          title: "Processors",
          create: "Create Processor",
          edit: "Edit Processor",
          delete: "Are you sure to remove this processor",
          delete_several: "¿Está seguro de eliminar",
        },
        banks: {
          title: "Banks",
          create: "Create Bank",
          edit: "Edit Bank",
          delete: "Are you sure to remove this bank",
          delete_several: "¿Está seguro de eliminar",
        },
        services: {
          title: "Services",
          create: "Create Services",
          edit: "Edit Services",
          delete: "Are you sure to remove this services",
          delete_several: "Are you sure to delete the selected resources?",
          b2p: "B2P",
          c2p: "C2P",
          paymentInquiry: "Payment Inquiry",
          immediateCredit: "Immediate Credit",
        },
        credentials: {
          title: "Credentials",
          create: "Create Credential",
          edit: "Edit Credential",
          delete: "Are you sure to remove this credential",
          delete_several: "Are you sure to delete the selected resources?",
        },
      },
      features: {
        Exchange: "Exchange",
        'Max amount change': "Max Amount Change",
        Maxamountchange: "Max Amount Change",
      },
      paymentMethods:{
        Immediatecredit: "Immediate credit",
        Card: "Card",
        QR: "Qr",
        Verification: "Verification",
        Cash: "Cash",
        Change: "Change",
        Keyentry: "Key entry",
        C2Ppayment: "C2P payment",
      },
    },
    fieldsName: {
      global: {
        name: "Name",
        feature: "Features",
        payment_method: "Payment methods",
        processor: "Processor",
        services: "service",
        status: "Estado",
        branch: "Branch",
        cashier: "Cashier",
        dateTime: "Date and Time",
        business: "Business",
        paymentMethod: "Payment method",
        teller: "Teller",
        terminal: "Terminal",
        category: "Category",
        totalCredit:"Credit totals",
        totalDebit:"Debit totals",
        grandTotals:"Grand totals",
        count: "Count",
        total: "Total amount",
        amount: "Amount",
        normalPrice: "Price",
        price: "Price in dollars",
        allTimes: "All times",
        lastWeek: "Last week",
        lastMonth: "Last month",
        actions: "Actions",
        select: "Select",
        businessSettings: "Business Settings",
        updateSettings: "Update Business",
        local_date: "Date",
        card_brand: "Card",
        batch_number: "Batch number",
        type: "Type",
        code: "Code",
        account_number: "Account number",
        date: "Date",
        batch: "Lote",
        sales: "Sales",
        annulMents: "Annulments",
        nro_card_brand:"Card number",
        loading: "Loading...",
        to: "to",
        order: "Order number",
        sold:"Sold",
        stock:"Stock",
        quantity:"Quantity",
        product_quantity:"Product quantity",
        secTotal: "Total amount Bs.",
        totalAmountRef: "Total amount Ref.",
        generic: "Generic",
        null: "",
      },
      users: {
        firstName: "First name",
        lastName: "Last name",
        branch: "Branch",
        email: "E-mail",
        business: "Business",
        role: "Role",
        password: "Password",
        newPassword: "New password",
        save: "Save",
        cancel: "Cancel",
      },
      product: {
        description: "Description",
        dropImg: "Drop an image here!",
        orClick: "Drop an image here or click here to upload an image",
        format: "PNG or JPG only",
        stateTaxable: "State taxable",
        taxable: "Taxable",
      },
      business: {
        maxAmountChange: "Maximum return amount",
        baseCurrency: "Base currency",
        displayCurrency: "Display currency",
        surchargeRate: "Surcharge rate",
        cashDiscountRate: "Cash discount rate",
        surcharge: "Surcharge",
        cashDiscount: "Cash discount",
        tip: "Tip",
        exchangeRate: "Exchange rate",
        keyEntry: "Key entry",
        tooltipDisplayCurrency: "Currency displayed in the prices",
        tooltipBaseCurrency: "Local currency",
        tooltipExchangeRate:
          "Here exchange rate between base currency and display currency",
        businessRegister: "Merchant ID",
        rif: "Rif",
        stateTax: "State Tax",
        retailManagerMerchant: "Retail Manager Merchant Id",
        acquiringBank: "Acquiring bank",
        ivuControl: "IVU Control",
        generalTax: "General Tax",
        zelle: "Zelle",
        cash: "Cash",
        change: "Change",
        verification: "Verification",
        qr:"QR",
        paymentDivision: "Payment Division",
        operator: "Operator",
        paymentInquiry: "Payment Inquiry",
        immediateCredit: "Immediate Credit",
        returnedBancaribe: "Returned Bancaribe",
        C2Pcollection: "C2P Collection",
        card: "Card",
        withoutStock: "Selling without stock"
      },
      branches: {
        state: "State",
        city: "City",
        address: "Address",
        phoneNumber: "Phone",
        codePhoneNumber: "Code",
        magicPayToken: "Magic Pay Token",
        catalog: "Catalog",
        keyboard_amount: "Keyboard Amount"
      },
      terminals: {
        serial: "Serial",
        status: "Status",
        model: "Model",
        file: "File",
        terminalId: "Identifier",
      },
      transactions: {
        date: "Date",
        time: "Time",
        authCode: "Auth code",
        transmitter: "Transmitter",
        mode: "Mode",
        subtotal: "Subtotal",
        tax: "Tax",
        tip: "Tip",
        idTransactions: "ID Transaction",
        status: "Status",
        surcharge: "Surcharge",
        approved: "Approved",
        approvedPartial: "Partial Approved",
        void: "Void",
        refund: "Refund",
        totalAmount: "Total amount",
        totalAmountRef: "Total amount Ref.",
        totalAmountUsd: "Total amount USD",
        secTotalAmountSec: "Total amount Bs.",
        appVersion: "App Version",
        keyEntry: "Key entry",
        contactless: "NFC",
        contact: "Chip",
        swipe: "Swipe",
        mobilePayment: "Mobile Payment",
        zelle: "Zelle",
        cash: "Cash",
        verification: "Verification",
        change: "Change",
        reference: "Reference",
        card: "Card",
        batch: "Lote",
        authorization: "Authorization",
        rif: "Rif",
        afil: "Afil",
        cashSale: "Cash Sale",
        debitSale: "Debit Sale",
        creditSale: "Credit Sale",
        totalRecords: "Total records",
        immediateCredit: "Immediate Credit",
        transfer: "Transfer"
      },
      orders: {
        date: "Date",
        time: "Time",
        authCode: "Auth code",
        transmitter: "Transmitter",
        mode: "Mode",
        subtotal: "Subtotal",
        tax: "Tax",
        tip: "Tip",
        idTransactions: "ID Transaction",
        status: "Status",
        surcharge: "Surcharge",
        approved: "Approved",
        approvedPartial: "Partial Approved",
        void: "Void",
        refund: "Refund",
        totalAmount: "Total amount",
        totalAmountRef: "Total amount Ref.",
        totalAmountUsd: "Total amount USD",
        secTotalAmountSec: "Total amount Bs.",
        appVersion: "App Version",
        keyEntry: "Key entry",
        contactless: "NFC",
        contact: "Chip",
        swipe: "Swipe",
        mobilePayment: "Mobile Payment",
        zelle: "Zelle",
        cash: "Cash",
        verification: "Verification",
        change: "Change",
        reference: "Reference",
        card: "Card",
        batch: "Lote",
        authorization: "Authorization",
        rif: "Rif",
        afil: "Afil",
        cashSale: "Cash Sale",
        debitSale: "Debit Sale",
        creditSale: "Credit Sale",
        totalRecords: "Total records",
        immediateCredit: "Immediate Credit",
        transfer: "Transfer"
      },
      orders: {
        date: "Date",
        time: "Time",
        authCode: "Auth code",
        transmitter: "Transmitter",
        mode: "Mode",
        subtotal: "Subtotal",
        tax: "Tax",
        tip: "Tip",
        idOrder: "ID Sale",
        status: "Status",
        surcharge: "Surcharge",
        approved: "Approved",
        approvedPartial: "Partial Approved",
        void: "Void",
        refund: "Refund",
        totalAmount: "Total amount",
        totalAmountUsd: "Total amount USD",
        totalAmountRef: "Total amount Ref.",
        secTotalAmountSec: "Total amount Bs.",
        appVersion: "App Version",
        keyEntry: "Key entry",
        contactless: "NFC",
        contact: "Chip",
        swipe: "Swipe",
        mobilePayment: "Mobile Payment",
        zelle: "Zelle",
        cash: "Cash",
        verification: "Verification",
        change: "Change",
        reference: "Reference",
        card: "Card",
        batch: "Lote",
        authorization: "Authorization",
        rif: "Rif",
        afil: "Afil",
        cashSale: "Cash Sale",
        debitSale: "Debit Sale",
        creditSale: "Credit Sale",
        totalRecords: "Total records",
        immediateCredit: "Immediate Credit",
        transfer: "Transfer"
      },
      customReport: {
        amount: "Amount",
        avgAmount: "Avg Amount",
      },
      soldProducts: {
        productName: "Product name",
        productId: "Product identifier",
        productPrice: "Product price",
      },
      networkSettings: {
        credentials: {
          network: "Network",
          merchant: "Merchant",
          user: "User",
        },
      },
    },
    services: {
      b2p: "Turned (B2P)",
      c2p: "Payment verification (C2P)",
      paymentInquiry: "Payment inquiry",
      immediateCredit: "Immediate credit",
    },
  },
};
const spanishMessages = {
  ra: {
    no_records: "No hay registros",
    weekDays: {
      sunday: "Domingo",
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Miercoles",
      thursday: "Jueves",
      friday: "Viernes",
      saturday: "Sabado",
      day: "Día"
    },
    errorChangePassword: {
      minimum_characters:"La longitud mínima de la contraseña es de 8 caracteres",
      containts_name_institution: "La contraseña no puede contener el nombre de la institución",
      containts_three_consecutive: "La contraseña no puede contener tres caracteres idénticos consecutivos",
      have_one_letters: "La contraseña debe tener al menos una letra",
      have_one_number: "La contraseña debe tener al menos un número",
      have_special_character: "La contraseña debe tener al menos  un carácter especial",
      have_blank_spave: "La contraseña no puede contener espacios en blanco",
      repeat_password: "La contraseña no debe ser la misma que las 5 últimas utilizadas"
    },
    auth: {
      auth_check_error: "Por favor inicie sesión para continuar",
      usernameField: "Nombre de usuario",
      passwordField: "Contraseña",
      emailField: "Ingrese su correo",
      verificationCodeField: "Código de verificación",
      newPasswordField: "Nueva contraseña",
      newPasswordConfirmField: "Confirmar nueva contraseña",
      otpField: "Código de seguridad",
      forgotPassword: "¿Olvidaste tu contraseña?",
      resendVerificationEmail: "Verificación de usuario",
      title: "Cambiar contraseña",
      title_otp: "Verificar Otp",
      description:
        "Te enviamos un código de verificación a tu correo, por favor ingrese el codigo en el campo correspondiente.",
      invalid_password: "Contraseña invalida",
      verification_failed:
        "Verificación fallida, por favor ingrese su correo en verificacion de usuario.",
      user_confirmed: "Usuario confirmado exitosamente",
      user_change_confirmed: "Usuario confirmado exitosamente, los cambios serán reflejados en el siguiente inicio de sesión",
      user_not_cofigure: "El usuario no se puede editar en este momento",
      verifyingAccount: "Verificando cuenta...",
      limitPassword: "Su contraseña vence en:",
      change_password: "Es necesario cambiar la contraseña del usuario.",
      success_change_password: "Cambio de contraseña correcto.",
      success_resend_otp: "Código de seguridad OTP reenviado a tu correo electrónico",
      error_resend_otp: "Existe un error al reenviar el código de seguridad OTP" ,
      pin_bancaribe: "Ingrese PIN",
      error_pin: "El PIN debe ser de 4 digitos"
    },
    notification: {
      terminal_not_found_error: "El terminal no existe",
      http_error: "Error de red. Intente de nuevo",
      server_error: "Internal server error",
      updated_success: "Recurso actualizado correctamente",
      created_success: "Recurso creado correctamente",
      deleted_success: "Recurso eliminado correctamente",
      not_found: "El recurso no existe",
      unexpected_error: "Ooops, ocurrio un error, intente de nuevo",
      password_changed_success: "La contraseña se cambio correctamente",
      invalid_code_error: "Código de verificación invalido",
      password_not_same_error: "Las contraseñas ingresadas no son iguales",
      invalid_email_error: "Correo invalido",
      check_email_success: "Revisa tu correo",
      cannot_delete_resource:
        "No se puede eliminar uno de los recursos seleccionados ya que posee datos asociados que dependen de ella.",
      cannot_delete_resource_banks:"No se puede eliminar porque los recursos (%{banks}) están relacionados con un comercio",
      fields_required: "Algunos campos estan vacios",
      extension_not_allowed: "Extensión no permitida",
      time_session: "El tiempo de sesión expiró",
      already_exist_resource: "El recurso ya existe.",
      not_existence:"El producto no tiene existencia.",
      already_exist_rif: "La Identificación del comerciante ya existe",
      required_rif:"Identificación del comercio es requerido",
      required_sec_currency: "Moneda secundaria es requerida",
      required_currency_rate: "La tasa de cambio es requerida",
      min_value_surcharge_cashdiscount:
        "La tasa de descuento o recargo no puede ser menor 1,00",
      max_value_surcharge_cashdiscount:
        "La tasa de descuento o recargo no puede ser mayor 4,00",
      max_value_taxes:
        "El impuesto general o estatal no puede ser mayor a 100,00",
      min_value_taxes: "El impuesto general o estatal no puede ser menor 1,00",
      account_already_confirmed: "Esta cuenta ya esta confirmada.",
      user_not_exist: "Este usuario no existe",
      exceeded_limit:
        "Has superado el número de intentos, vuelve a intentarlo más tarde.",
      max_price: "Monto maximo es 9.999.999,99$",
      min_price: "Monto minimo es 0,01$",
      min_phone_number:
        "El número de teléfono debe tener al menos 10 caracteres",
      deleted_error: "No puede eliminar el usuario que esta en sesión",
      password_temporal_not_found: "No puedes cambiar contraseña sin un usuario asociado",
      otp_not_found: "No puedes ingresar otp sin un usuario asociado",
      otp_not_equeals: "El Otp no es correcto",
      otp_expired: "El código OTP expiro, por favor reenvialo de nuevo",
      enter_otp: 'Ingrese el código de seguridad que enviamos a tu correo electrónico',
      resend_otp: '¿No recibiste la clave? Reenviar',
      resend_otp_in: "Tu código expira en ",
      seconds: "segundos.",
      password_temporal_not_process: "No se puede procesar el cambio de contraseña en este momento",
      pin_not_process: "No se puede procesar el cambio de PIN en este momento",
      pin_changed_success: "El PIN se cambio correctamente",
      columns_not_found:"Columnas no encontradas revisar nuestras plantilla, las columnas no encontradas son: %{columns}",
      product_load:"Primero debe cargar los productos para poder avanzar",
      created_success_stock:"Productos actualizados correctamente, de %{total} productos se actualizaron %{products}, los productos actualizados fueron: %{products_names}",
      created_success_product:"Productos (%{total}) creados correctamente",
      created_success_images:"Imagenes (%{total}) guardadas correctamente",
      error_product_quantity : "No se permite la cantidad del producto (quantity) con valores negativos. se encontraron %{products} producto(s) con valores negativos.",
      error_special_characters : "No se permite caracteres especiales en las columnas precios (price) y cantidad (quantity).",
      error_id: "Los siguientes id de productos no existen : %{ids}",
      error_product_price : "No se permite el precio del producto (price) con valores negativos. se encontraron %{products} producto(s) con valores negativos.",
      error_special_characters_quantity : "No se permite caracteres especiales en la columna cantidad (quantity).",
      quantity_error:"Debes agregar una cantidad",
      catalogOrKeyboardAmount: "Debe seleccionar al menos una opcion entre Catalogo y Monto por teclado",
      acceptTerms:"Debe aceptar los términos y condiciones",
      min_price_change: "Monto minimo para vuelto es 0,01$",
      invalid_business_name: "El nombre del comercio no puede contener caracteres especiales",
      invalid_branch_name: "El nombre de la sucursal no puede contener caracteres especiales",
      invalid_branch_merchant_id_min :"El Rif del comercio debe tener al menos 7 caracteres.",
      invalid_branch_merchant_id_max :"El Rif del comercio no puede tener más de 10 caracteres.",
      invalid_branch_account_number :"El número de cuenta debe tener exactamente 20 caracteres."
    },
    action: {
      create: "Crear",
      save: "Guardar",
      edit: "Editar",
      editImage: "Editar imagen",
      cancel: "Cancelar",
      delete: "Eliminar",
      addFilter: "Agregar filtro",
      export: "Exportar",
      logout: "Cerrar sesión",
      goBack: "Regresar",
      update: "Actualizar",
      quickFilter: "Filtro rapido",
      select: "Seleccionar",
      search: "Buscar",
      login: "Ingresar",
      resetPassword: "Cambiar contraseña",
      resentPassword: "Reenviar contraseña",
      newPassword: "Guardar nueva contraseña",
      continue: "Continuar",
      extend: "Extender",
      close: "Cerrar",
      retry: "Reintentar",
      load: "Cargar",
      submit: "Enviar",
      changePassword: "Cambiar contraseña",
      firstPage: "Primera página",
      lastPage: "Ultima página",
      from: "Desde",
      to: "Hasta",
      dateRange: "Rango de fecha",
      userSettings: "Vista personalizada",
      userProfile: "Configuración de Usuario",
      clear: "Limpiar",
      discharge: "Descargar",
      zoom: "Acercar",
      changePin: "Cambiar PIN",
      newPin: "Guardar nuevo pin",
      batch:"Cargar productos en lote",
      next:"Siguiente",
      back:"Atrás",
      finish:"Terminar",
      stock:"Cargar stock en lotes",
      remove:"Eliminar",
      add:"Agregar"
    },
    page: {
      not_found: "Página no encontrada",
      page: "Página",
      of: "de",
    },
    message: {
      not_found: "Recurso no encontrada.",
      time_logout: "Quedan menos de 30 segundos para cerrar la sesión.",
      error_get_data:
        "Error inesperado al recibir datos, por favor intente de nuevo.",
      confirm: "Confirmar",
      cancel: "Cancelar",
      stock:"Para la carga de stock por lote debes subir un archivo Excel con el id, nombre(name) y la cantidad(quantity), aquí puedes descarga el Excel con los productos existentes, solo debes cambiar la cantidad positivo si vas a sumar (20) y negativos si vas a restar (-20)",
      productBatch:"Para la carga masiva de productos debes subir una Excel con el nombre(name), descripción(description), precio en dolares (price) y cantidad(quantity), en el botón 'DESCARGAR PLANTILLA' puedes descargar un ejemplo.",
      imageZip:"Para la carga masiva de imágenes debes cargar un archivo zip que contengas las imágenes de los productos, cada imagen de tener el mismo nombre que el producto agregado anteriormente de lo contrario no se guardaran."
    },
    views: {
      dashboard: {
        title: "Tablero",
        dailySales: "Ingresos Diarios",
        weeklySales: "Ingresos Semanales",
        monthlySales: "Ingresos Mensuales",
        dailyC: "Comparación por día",
        weeklyC: "Comparación por semana",
        monthlyC: "Comparación por mes",
        current: "Actual",
        previous: "Previo",
        yesterday: "Ayer",
        salesAmount: "Gráfica de Operaciones",
        today: "Hoy",
        week: "Semana",
        monthByWeek: "Mes por semanas",
        monthByDay: "Mes por días",
      },
      settings: {
        title: "Configuraciones",
        titleAdjustmentBusinesses: "Ajuste de Comercios",
        titleUsers: "Usuarios",
        titleBranches: "Sucursales",
        titleTerminals:"Terminales",
        titleProducts: "Productos",
        converter: "Conversor de Moneda",
        language: "Lenguaje",
        businessRegister: "Identificación del comerciante",
        businessName: "Nombre de comercio",
      },
      products: {
        title: "Productos",
        create: "Crear Producto",
        edit: "Editar Producto",
        detail: "Detalle Producto",
        delete: "¿Está seguro de eliminar este producto?",
        delete_several: "¿Está seguro de eliminar los recursos seleccionados?",
        loadFile: "Cargar archivo de imágenes en zip",
        loadFileImages: "Cargar archivo de imágenes",
        loadFileStock:"Cargar archivo de existencias",
        onlyFormat:"Solo archivo .zip",
      },
      categories: {
        title: "Categorias",
        create: "Crear Categoría",
        edit: "Editar Categoría",
        delete: "¿Está seguro de eliminar esta Categoría?",
        delete_several: "¿Está seguro de eliminar los recursos seleccionados?",
      },
      terms:{
        title: "TÉRMINOS Y CONDICIONES CAJA DIGITAL BANCARIBE",
        Content:"What is Lorem Ipsum? Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
      },
      users: {
        title: "Usuarios",
        create: "Crear Usuario",
        edit: "Editar Usuario",
        detail: "Detalle Usuario",
        delete: "¿Está seguro de eliminar este usuario?",
        delete_several: "¿Está seguro de eliminar los recursos seleccionados?",
      },
      business: {
        title: "Comercios",
        create: "Crear Comercio",
        edit: "Editar Comercio",
        detail: "Detalle Comercio",
        delete: "¿Está seguro de eliminar este comercio?",
        delete_several: "¿Está seguro de eliminar los recursos seleccionados?",
        loadFile: "Cargar archivo de productos",
      },
      branches: {
        title: "Sucursales",
        create: "Crear Sucursal",
        edit: "Editar Sucursal",
        detail: "Detalle Sucursal",
        delete: "¿Está seguro de eliminar esta sucursal ?",
        delete_several: "¿Está seguro de eliminar los recursos seleccionados?",
      },
      terminals: {
        title: "Terminales",
        create: "Crear Terminal",
        edit: "Editar Terminal",
        detail: "Detalle Terminal",
        dropFile: "Arrastra aqui un archivo",
        orClickFile: "O click aqui para subir el archivo",
        onlyFormat: "Solo archivos excel o csv",
        loadFile: "Seleccionar Archivo",
        downloadTemplate: "Descargar plantilla",
        delete: "¿Está seguro de eliminar este terminal?",
        delete_several: "¿Está seguro de eliminar los recursos seleccionados?",
        bulkLoad: "Carga masiva de terminales",
        textUpload:"Arrastra un archivo aquí o haz click para subirlo. Solo archivos excel o csv",
        textUploadTxt:"Arrastra un archivo aquí o haz click para subirlo. Solo archivos txt",
        textUploadZip:"Arrastra un archivo aquí o haz click para subirlo. Solo archivo .zip",
      },
      orders: {
        title: "Ventas",
        ordersTotal: "Ventas: ",
        ordersSales: "Monto: ",
        orderDetail: "Detalles de la venta:",
        transactionDetail: "Detalles de la transacción: ",
      },
      transactions: {
        title: "Transacciones",
        create: "Crear Transacción",
        edit: "Editar Transacción",
        detail: "Detalle Transacción",
        delete: "¿Está seguro de eliminar esta transacción?",
        delete_several: "¿Está seguro de eliminar los recursos seleccionados?",
        transactionTotal: "Transacciones: ",
        transactionSales: "Ventas: ",
      },
      reports: {
        title: "Reportes",
        titleCustomR: "Reporte Dinámico",
        titleSoldP: "Productos Vendidos",
        titleCloseR: "Reporte de Cierre",
      },
      networkSettings: {
        title: "Configuración de redes",
        features: {
          title: "Funcionalidades",
          create: "Crear funcionalidad",
          edit: "Editar funcionalidad",
          delete: "¿Está seguro de eliminar esta funcionalidad?",
          delete_several:
            "¿Está seguro de eliminar los recursos seleccionados?",
        },
        payment_methods: {
          title: "Métodos de pago",
          create: "Crear método de pago",
          edit: "Editar método de pago",
          delete: "¿Está seguro de eliminar este método de pago?",
          delete_several:
            "¿Está seguro de eliminar los recursos seleccionados?",
        },
        processors: {
          title: "Procesadores",
          create: "Crear procesador",
          edit: "Editar procesador",
          delete: "¿Está seguro de eliminar este procesador?",
          delete_several:
            "¿Está seguro de eliminar los recursos seleccionados?",
        },
        banks: {
          title: "Bancos",
          create: "Crear Bancos",
          edit: "Editar Bancos",
          delete: "¿Está seguro de eliminar este banco?",
          delete_several:
            "¿Está seguro de eliminar los recursos seleccionados?",
        },
        services: {
          title: "Servicios",
          create: "Crear Servicio",
          edit: "Editar Servicio",
          delete: "¿Está seguro de eliminar este Servicio?",
          delete_several:
            "¿Está seguro de eliminar los recursos seleccionados?",
          b2p: "Vuelto",
          c2p: "Verificacion de Pago",
          paymentInquiry: "Consulta de pago",
          immediateCredit: "Credito inmediato",
        },
        credentials: {
          title: "Crendenciales",
          create: "Crear Brendencial",
          edit: "Editar Crendencial",
          delete: "¿Está seguro de eliminar esta crendencial?",
          delete_several:
            "¿Está seguro de eliminar los recursos seleccionados?",
        },
      },
      features: {
        Exchange: "Cambio",
        'Max amount change': "Máximo monto de vuelto",
        Maxamountchange: "Máximo monto de vuelto",
      },
      paymentMethods:{
        Immediatecredit: "Credito inmediato",
        Card: "Tarjeta",
        QR: "Qr",
        Verification: "Verificación",
        Cash: "Efectivo",
        Change: "Vuelto",
        Keyentry: "Key entry",
        C2Ppayment: "Cobro C2P",
      },
    },
    fieldsName: {
      global: {
        name: "Nombre",
        feature: "Funcionalidades",
        payment_method: "Métodos de pago",
        processor: "Procesador",
        services: "Servicios",
        status: "Status",
        branch: "Sucursal",
        cashier: "Cajero",
        dateTime: "Fecha y Hora",
        business: "Comercio",
        paymentMethod: "Metodo de pago",
        teller: "Cajero",
        terminal: "Terminal",
        category: "Categoría",
        totalCredit:"Totales de credito",
        totalDebit:"Totales de  débito",
        grandTotals:"Totales generales",
        count: "Cantidad",
        total: "Monto total",
        amount: "Monto",
        normalPrice: "Precio",
        price: "Precio en dolares",
        allTimes: "Todo",
        lastWeek: "Ultima semana",
        lastMonth: "Ultimo mes",
        actions: "Acciones",
        select: "Seleccionar",
        businessSettings: "Configuración de comercio",
        updateSettings: "Actualizar Comercios",
        local_date: "Fecha",
        card_brand: "Tarjeta",
        batch_number: "Numero de lote",
        type: "Tipo",
        code: "Codigo",
        account_number: "Número de cuenta",
        date: "Fecha",
        batch: "Lote",
        sales: "Compra",
        annulMents:"Anulaciones",
        nro_card_brand:"Número de Tarjeta",
        loading: "Cargando...",
        to: "a",
        order: "Número de Orden",
        sold:"Vendidos",
        stock:"Existencia",
        quantity:"Cantidad",
        product_quantity:"Cantidad del producto",
        secTotal: "Monto toal Bs",
        totalAmountRef: "Monto total Ref.",
        generic: "Generico",
        null: "",
      },
      users: {
        firstName: "Nombre",
        lastName: "Apellido",
        branch: "Sucursal",
        email: "Correo electrónico",
        business: "Comercio",
        role: "Rol",
        password: "Contraseña",
        newPassword: "Nueva contraseña",
        cancel: "Cancelar",
        save: "Guardar",
      },
      product: {
        description: "Descripción",
        dropImg: "Arrastra la imagen aqui",
        orClick:
          "Arrastra la imagen aqui o haz click aqui para subir una imagen",
        format: "Solo PNG o JPG",
        stateTaxable: "Impuesto estatal",
        taxable: "Impuesto",
      },
      business: {
        maxAmountChange: "Monto máximo de vuelto",
        baseCurrency: "Moneda base",
        displayCurrency: "Moneda al mostrar",
        surchargeRate: "Tasa de recargo",
        cashDiscountRate: "Tasa de descuento",
        surcharge: "Recargo",
        cashDiscount: "Descuento",
        tip: "Propina",
        exchangeRate: "Tasa de cambio",
        keyEntry: "Entrada manual",
        tooltipDisplayCurrency: "Moneda mostrada en los precios",
        tooltipBaseCurrency: "Moneda local",
        tooltipExchangeRate:
          "Tasa de cambio entre moneda base y moneda mostrada",
        businessRegister: "Identificación del comerciante",
        rif: "Rif",
        acquiringBank: "Banco adquiriente",
        retailManagerMerchant: "ID de comerciante del administrador minorista",
        ivuControl: "IVU Control",
        generalTax: "Impuesto general",
        zelle: "Zelle",
        cash: "Efectivo",
        change: "Vuelto",
        verification: "Verificación",
        qr:"QR",
        paymentDivision: "Pago dividido",
        operator: "Operador",
        stateTax: "Impuesto estatal",
        paymentInquiry: "Consulta de pago",
        immediateCredit: "Crédito Inmediato",
        returnedBancaribe: "Devolucion Bancaribe",
        C2Pcollection: "Recopilación C2P",
        card: "Tarjeta",
        withoutStock: "Vender sin existencia"
      },
      branches: {
        state: "Estado",
        city: "Ciudad",
        address: "Dirección",
        phoneNumber: "Telefono",
        codePhoneNumber: "Código",
        magicPayToken: "Token Magic Pay",
        catalog: "Catalogo",
        keyboard_amount: "Monto por Teclado"
      },
      terminals: {
        serial: "Serial",
        status: "Estado",
        model: "Modelo",
        file: "Archivo",
        terminalId: "Identificador",
      },
      transactions: {
        date: "Fecha",
        time: "Hora",
        authCode: "Codigo de autorización",
        transmitter: "Transmisor",
        mode: "Modo",
        subtotal: "Subtotal",
        tax: "Impuesto",
        tip: "Propina",
        idTransactions: "ID Transacción",
        status: "Estado",
        surcharge: "Recargo",
        approved: "Aprobado",
        approvedPartial: "Aprobación parcial",
        void: "Anulación",
        refund: "Devolución",
        totalAmount: "Monto total",
        totalAmountUsd: "Monto total USD",
        totalAmountRef: "Monto total Ref.",
        secTotalAmountSec: "Monto total Bs.",
        appVersion: "Versión de App",
        keyEntry: "Entrada Manual",
        contactless: "NFC",
        contact: "Chip",
        swipe: "Banda",
        zelle: "Zelle",
        cash: "Efectivo",
        verification: "Pago móvil",
        change: "Vuelto",
        reference: "Referencia",
        card: "Tarjeta",
        batch: "Lote",
        authorization: "Autorización",
        rif: "Rif",
        afil: "Afil",
        cashSale: "Venta Efectivo",
        debitSale: "Venta Débito",
        creditSale: "Venta Crédito",
        totalRecords: "Total registros",
        immediateCredit: "Credito inmediato",
        transfer: "Tranferencia"
      },
      orders: {
        date: "Fecha",
        time: "Hora",
        authCode: "Codigo de autorización",
        transmitter: "Transmisor",
        mode: "Modo",
        subtotal: "Subtotal",
        tax: "Impuesto",
        tip: "Propina",
        idOrder: "ID Venta",
        status: "Estado",
        surcharge: "Recargo",
        approved: "Aprobado",
        approvedPartial: "Aprobación parcial",
        void: "Anulación",
        refund: "Devolución",
        totalAmount: "Monto total",
        totalAmountRef: "Monto total Ref.",
        totalAmountUsd: "Monto total USD",
        secTotalAmountSec: "Monto total Bs.",
        appVersion: "Versión de App",
        keyEntry: "Entrada Manual",
        contactless: "NFC",
        contact: "Chip",
        swipe: "Banda",
        zelle: "Zelle",
        cash: "Efectivo",
        verification: "Pago móvil",
        change: "Vuelto",
        reference: "Referencia",
        card: "Tarjeta",
        batch: "Lote",
        authorization: "Autorización",
        rif: "Rif",
        afil: "Afil",
        cashSale: "Venta Efectivo",
        debitSale: "Venta Débito",
        creditSale: "Venta Crédito",
        totalRecords: "Total registros",
        immediateCredit: "Credito inmediato",
        transfer: "Tranferencia"
      },
      customReport: {
        amount: "Monto",
        avgAmount: "Monto promedio",
      },
      soldProducts: {
        productName: "Nombre producto",
        productId: "Identificador producto",
        productPrice: "Precio producto",
      },
      networkSettings: {
        credentials: {
          network: "Red",
          merchant: "Comerciante",
          user: "Usuario",
        },
      },
    },
    services: {
      b2p: "Vuelto (B2P)",
      c2p: "Cobro (C2P)",
      paymentInquiry: "Consulta de pago",
      immediateCredit: "Credito inmediato",
    },
  },
};

const messages = {
  es: spanishMessages,
  en: englishMessages,
};

let languageStorage = !window.localStorage.getItem("language")
  ? themeConfig.companyName.includes("Bancaribe")
    ? "es"
    : "en"
  : window.localStorage.getItem("language");

const i18nProvider = polyglotI18nProvider(
  (locale) => messages[locale],
  languageStorage
);

export default i18nProvider;
